module.exports = __webpack_public_path__ + "img/dream_invite_order.5aee5375.png";